import M from 'backbone.marionette'
import T from './coursinscrits.html'
import moment, { relativeTimeThreshold } from 'moment';
import { FormElement } from '../../../utils/bootstrap/formelement';
import { Toast } from '../../../utils/bootstrap/toast'
import { FormHandler } from '../../../utils/bootstrap/form/formhandler';
import { AjouterCours } from './ajoutercours';
import { ProgrammeSelector } from '../programmeSelector';

const CoursItem = M.View.extend({
    tagName:'tr',
    template: _.template('<td><%=cours.CodeCours%></td><td><%=cours.NomCours%></td><td><%=inscriptionc.DateInscription%></td><td><%=cours.Duree%> H</td><td><button class="btn btn-danger btn-sx btnRetirer">Retirer</button></td>'),
    triggers: {
        'click .btnRetirer':'retirer:cours'
    }

})
const CoursList = M.CollectionView.extend({
    template: _.template(''),
    tagName: 'tbody',
    childView: CoursItem,
    childViewTriggers: {
        'retirer:cours':'retirer:cours'
    },
    childViewOptions: function(){
        return {
            controller: this.getOption('controller')
        };
    },
    viewFilter: function(view){
        console.log('cours', view.model.get('cours').NoCours, this.getOption('controller').get('currCours').includes(view.model.get('cours').NoCours))
        return this.getOption('controller').get('currCours').includes(view.model.get('cours').NoCours)
    }
});

export const CoursInscritsView = M.View.extend({
    template: _.template(T),
    id: 'etudiantPartial',
    regions: {
        'content':{
            el:'tbody.content',
            replaceElement: true
        },
        'ajouterCours':'.ajouterCours',
        'programmeSelector':'.programmeSelector'
    },
    
    childViewTriggers: {
        'retirer:cours':'retirer:cours',
        'ajouter:cours':'ajouter:cours',
    },
    modelEvents: {
        'change:currentInscriptionP':'render'
    },
    collection: null,
    newCours: null,
    initialize: function(){       
        /*
        this.collection = new Backbone.Collection();
        this.collection.add(this.getOption('controller').get('inscriptionc').reduce((prev,item) => {
            if(item.get('cours')){
                prev.push(_.extend(item.get('inscriptionc'), {id: item.get('id'), cours: item.get('cours')}));
            }
            return prev
        }, []));
        */
        this.newCours = new Backbone.Model()
    },
    onDestroy: function(){
        this.collection = null;
    },
    onRender: function(){

        this.newCours.set({
            NoProgramme: this.getOption('controller').get('currentProgramme')
        })

        this.showChildView('content', new CoursList({
            collection: this.model.get('inscriptionc'),
            controller: this.model,
            
        }))
        this.showChildView('programmeSelector', new ProgrammeSelector({
            model: this.getOption('controller')
        }))
        this.renderAjouterCours();
    },
    renderAjouterCours: function(){
        this.showChildView('ajouterCours', new AjouterCours({
            model: this.newCours,
            controller: this.model
        }))
    },
    onAjouterCours: function(view){
        const formHandler = new FormHandler();
        formHandler.setModel(view.model);
        formHandler.save('api/etudiants/ajouterinscriptionc',
            (response) => {
                this.getOption('controller').get('inscriptionc').add(response.inscription);
                Toast.add('Cours « ' + response.inscription.cours.NomCours + ' » ajouté avec succès !','success');
                if(response.paiement){
                    this.getOption('controller').get('paiement').add(response.paiement)
                }
                this.renderAjouterCours();
            },
            (errors) => {
                if(errors){
                    Toast.add(errors.join('<br />'), 'danger');
                }else{
                    RacAPI.handleError(errors);
                }
            }
        )
    },
    onRetirerCours: function(view){
        if(confirm('Voulez vous vraiment retirer ce cours ?')){
            const id = view.model.get('NoInscriptionC');
            $.ajax({
                url: 'api/etudiants/retirerinscriptionc/'+id,
                type: 'post',
                success: () => {
                    this.model.get('inscriptionc').remove(id);
                    this.collection.remove(id);
                    Toast.add('Cours retiré avec success !', 'success');
                },
                error: () => {
                    Toast.add('Le cours ne peut être retiré', 'danger');
                }
            })
        }
    }
})